import {
    Box,
    Button,
    Heading,
    HStack,
    Link,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    VStack
} from '@chakra-ui/react';
import { useMicrositeConfig } from '@components/Site/provider/MicrositeConfigProvider';
import { serverTimestamp, useFirebaseApp } from '@lib/firebase';
import { intl_html_values } from '@lib/localization/intl';
import { Formik } from 'formik';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const PrivacyPolicyModal = () => {
    const [submitError, setSubmitError] = useState<string | null>(null);
    const { userData, userDataDocRef } = useFirebaseApp();
    const { event } = useMicrositeConfig();

    if (!userData || !userDataDocRef) {
        return null;
    }

    const ext_url = event
        ? typeof localStorage !== 'undefined'
            ? localStorage.getItem(`ext_url_${event.id}`) || event.ext_url
            : event.ext_url
        : '';

    return (
        <Modal
            isOpen={true}
            onClose={() => {
                return false;
            }}
            size="lg"
            colorScheme="blue">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader />
                <ModalBody>
                    <Formik
                        initialValues={{
                            efn_number: userData.efn_number || ''
                        }}
                        onSubmit={async () => {
                            setSubmitError(null);

                            try {
                                await userDataDocRef?.set(
                                    {
                                        accepted_privacy_policy: true,
                                        updated_at: serverTimestamp(),
                                        updated_privacy_policy_at: serverTimestamp()
                                    },
                                    { merge: true }
                                );
                            } catch (err) {
                                setSubmitError(err.message);
                            }
                        }}>
                        {({ handleSubmit, isSubmitting, submitForm }) => (
                            <form onSubmit={handleSubmit}>
                                <VStack align="stretch" spacing="4">
                                    <Heading as="h2" size="sm" my={2}>
                                        Data Policy
                                    </Heading>
                                    <Box>
                                        <Box>
                                            To view WebUp you must accept the{' '}
                                            <Link
                                                colorScheme={'blue'}
                                                isExternal
                                                href={
                                                    'https://www.cmed.org.uk/privacy_policy-terms_and_conditions'
                                                }>
                                                <Text as={'u'}> data policy agreement </Text>
                                            </Link>
                                            and confirm that you are a Healthcare professional.
                                        </Box>
                                        <Box textAlign="center">{submitError}</Box>
                                        <HStack pt={4} flexDir="row-reverse" spacing={1}>
                                            <Button
                                                ml={2}
                                                colorScheme="blue"
                                                disabled={isSubmitting}
                                                onClick={() => {
                                                    submitForm();
                                                }}>
                                                <FormattedMessage
                                                    id="common.accept"
                                                    defaultMessage="Accept"
                                                    values={{
                                                        ...intl_html_values
                                                    }}
                                                />
                                            </Button>
                                            <Button
                                                colorScheme="gray"
                                                disabled={isSubmitting}
                                                as="a"
                                                href={ext_url ?? ''}>
                                                <FormattedMessage
                                                    id="common.reject"
                                                    defaultMessage="Reject"
                                                    values={{
                                                        ...intl_html_values
                                                    }}
                                                />
                                            </Button>
                                        </HStack>
                                    </Box>
                                </VStack>
                            </form>
                        )}
                    </Formik>
                </ModalBody>
                <ModalFooter />
            </ModalContent>
        </Modal>
    );
};

export default PrivacyPolicyModal;
